import React, { useEffect, useState, useRef } from "react";
import { Carousel, Card, Container } from "react-bootstrap";
import "./otp.css";
import Img1 from "../../assets/images/login/Img1.png";
import Img2 from "../../assets/images/login/Img2.png";
import Img3 from "../../assets/images/login/Img3.png";
import Img4 from "../../assets/images/login/Img4.png";
import Img5 from "../../assets/images/login/Img5.png";
import logo from "../../assets/images/login/Nathicharami Logo.png";
import cornerImg from "../../assets/images/login/corner.png";
import { BsFillTelephoneFill } from "react-icons/bs";
import PinField from "react-pin-field";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { axiosInstance } from "../../axiosInstance";
import Preloader from "../../Components/Loader/Loader";

export function Otp() {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  const [timer, setTimer] = useState(30); // 30 seconds countdown
  const [canResend, setCanResend] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setTimeout(() => setTimer(timer - 1), 1000);
    } else {
      setCanResend(true);
    }
    return () => clearTimeout(countdown);
  }, [timer]);

  const handleResend = async () => {
    // setOtp("");
    setTimer(30);
    setCanResend(false);
    try {
      const phoneNumber = Number(localStorage.getItem("phoneNumber"));
      console.log("p.n", phoneNumber);
      const response = await axiosInstance.post("resend-otp", { phoneNumber });
      if (response.data.status === true) {
        toast.success(response.data.message || "OTP send successful!");
        console.log("resended...");
        localStorage.setItem("token", response.data.token);
        // setTimeout(() => {
        //   navigate("/otp");
        // }, 3000);
      } else {
        toast.error("OTP verification failed! Please try again.");
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
      toast.error("Please enter valid OTP");
    }
  };

  const handleSubmit = async () => {
    if (!otp || otp.length !== 6) {
      toast.error("Please enter a valid OTP.");
      return;
    }
    setLoading(true);
    try {
      const phoneNumber = localStorage.getItem("phoneNumber").toString();
      const otpNumber = otp.toString();
      console.log("Phone number and OTP:", phoneNumber, otpNumber);

      if (isNaN(phoneNumber) || isNaN(otpNumber)) {
        toast.error("Invalid phone number or OTP format.");
        return;
      }

      const response = await axiosInstance.post("otp-verification", {
        phoneNumber,
        otp: otpNumber,
      });
      console.log("OTP verification response:", response);

      if (response.data.status === true) {
        if (response.data.is_existing === true) {
          toast.success(
            response.data.message || "OTP verification successful!",
          );
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("public_token", response.data.public_token);
          localStorage.setItem(
            "user_category",
            JSON.stringify(response.data.category),
          );
          setTimeout(() => {
            navigate("/home");
          }, 3000);
        } else {
          toast.success(
            response.data.message || "OTP verification successful!",
          );
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("temp_token", response.data.token);
          localStorage.setItem("public_token", response.data.public_token);
          localStorage.setItem(
            "user_category",
            JSON.stringify(response.data.category),
          );
          setTimeout(() => {
            navigate("/signup");
          }, 3000);
        }
      } else {
        toast.error("OTP verification failed! Please try again.");
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
      toast.error("Please enter valid OTP");
      setLoading(false);
    } finally {
      setLoading(false); // Stop loader
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleSubmit();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [otp]);

  return (
    <>
      {loading && <Preloader />}
      <ToastContainer />
      <div className="loginContainer">
        <div className="loginLeft">
          <Carousel className="carousel">
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img1} />
                  </div>
                  <div className="carousel-title">Create Perfect Matches</div>
                  <div className="carousel-desc">
                    Join Nathicharami’s trusted network of matchmaking
                    professionals.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img2} />
                  </div>
                  <div className="carousel-title">Capture Love Stories</div>
                  <div className="carousel-desc">
                    Connect with couples seeking timeless wedding memories.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img3} />
                  </div>
                  <div className="carousel-title">Enhance Bridal Radiance</div>
                  <div className="carousel-desc">
                    List your services and get booked by brides and grooms.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img4} />
                  </div>
                  <div className="carousel-title">Spread the Love</div>
                  <div className="carousel-desc">
                    Promote Nathicharami and earn rewards for every successful
                    match.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
            <Carousel.Item>
              <Card className="carousel-card">
                <Card.Body>
                  <div className="carouselImg">
                    <img src={Img5} />
                  </div>
                  <div className="carousel-title">
                    Host Unforgettable Weddings
                  </div>
                  <div className="carousel-desc">
                    Showcase your venue to couples dreaming of their perfect
                    wedding.
                  </div>
                </Card.Body>
              </Card>
            </Carousel.Item>
          </Carousel>
        </div>
        <div className="login-right">
          <div>
            <div className="loginLogo">
              <img src={logo} />
            </div>
            <div className="loginRight-text">OTP</div>
            <div className="opt-desc">
              Enter the verification Code sent to your number
            </div>
            <form
              onSubmit={(e) => {
                e.preventDefault(); // prevent default form submission
                handleSubmit(); // manually trigger OTP submit logic
              }}
            >
              {/* <div className="pinFieldContainer">
                <PinField
                  length={6}
                  //  onChange={(value) => setOtp(value)}
                  //  onComplete={(value) => formik.setFieldValue("otp", value)}
                  onChange={(value) => setOtp(value)} // Update OTP value in state
                  validate="0123456789"
                  autoFocus
                  className="pinfieldNumbers"
                />
              </div> */}
              <div>
                <input
                  type="number"
                  className="mobile-otp-input form-label"
                  value={otp}
                  maxLength={6}
                  onChange={(e) => {
                    const val = e.target.value.slice(0, 6);
                    if (/^\d*$/.test(val)) setOtp(val);
                  }}
                  placeholder="Enter 6 digit OTP"
                />
              </div>

              <div>
                <span> Didn't receive the code? </span>
                <button
                  onClick={handleResend}
                  disabled={!canResend}
                  style={{
                    marginTop: "20px",
                    padding: "10px 5px",
                    fontSize: "16px",
                    cursor: canResend ? "pointer" : "not-allowed",
                    color: canResend ? "#F24464 " : "#ccc",
                    backgroundColor: "transparent",
                    //   color: "white",
                    border: "none",
                    borderRadius: "5px",
                  }}
                >
                  {canResend ? "Resend OTP" : `Resend in ${timer}s`}
                </button>
              </div>
              <div className="btnSend">
                <button type="submit">Submit</button>
              </div>
            </form>
          </div>
        </div>

        <div className="cornerImg">
          <img src={cornerImg} />
        </div>
      </div>
    </>
  );
}
